import { render, staticRenderFns } from "./ProductRemarkForm.vue?vue&type=template&id=4c456d1e&"
import script from "./ProductRemarkForm.vue?vue&type=script&lang=js&"
export * from "./ProductRemarkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports